import { GeomapUtil, RouteObject } from "../../geomapUtil.js"
import { Button, buttonDefaultStyle } from "../../../core/components/button.js";
import { DirectionsCommonProps } from "../../directions/directions.js";
import { PerimeterSearchContextMenu, PerimeterSearchContextMenuTranslations } from "./perimeterSearchContextMenu.js";
import { WaypointType } from "./waypoint.js";
import React from "react";
export class Route extends React.Component<RouteProps, RouteState>{
    private _routeDivRef: HTMLDivElement;
    private _geomapUtil: GeomapUtil = GeomapUtil.getInstance();
    private _conversionFactor: number = 1.609344;
    private _regularStyle: React.CSSProperties;
    private _collapsedStyle: React.CSSProperties;
    private _contextMenuRef: HTMLElement;
    private _buttonBarStyle: React.CSSProperties;
    private _perimeterSearchContextRef: PerimeterSearchContextMenu;

    constructor(props) {
        super(props);

        const color = this._geomapUtil.getColor(this.props.route.id);

        this._regularStyle = {
            right: "0px",
            borderRadius: "0%",
            height: "100%",
            width: "100%",
            display: "block",
            boxShadow: `0px 2px 2px 0px ${color}, 0px 3px 1px -2px ${color}, 0px 1px 5px 0px ${color}`
        };

        this._collapsedStyle = {
            right: "-320px",
            borderRadius: "100%",
            height: "50px",
            width: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: `0px 2px 2px 0px ${color}, 0px 3px 1px -2px ${color}, 0px 1px 5px 0px ${color}`
        };

        this._buttonBarStyle = {
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 3px 0px 0px",
            margin: "auto",
            borderTop: "lightgrey",
            borderTopStyle: "solid",
            borderTopWidth: "thin"
        };

        this.state = {
            routeName: props.route.name ? props.route.name : this.props.translations["GeoMap.Container"] + this.props.route.id,
            collapsed: !!props.route.hide,
            pinsHidden: false,
            isEditMode: false
        };
    }

    private _getRouteButtons = () => {
        let ba = [];
        if (this.props.route.waypoints.length > 1)
            ba.push(<Button handleClick={() => { this.props.draw(this.props.route.id) }}
                key={kendo.guid()} title={this.props.translations["GeoMap.ZeichneRoute"]} iconName={"route"} buttonStyle={{ marginLeft: "5px" }} />);
        if (this.props.route.waypoints.length > 3)
            ba.push(<Button handleClick={() => { this.props.optimize(this.props.route.id) }}
                key={kendo.guid()} title={this.props.translations["GeoMap.OptimizeRoute"]} iconName={"tachometer-fastest"} />);
        return ba;
    }

    private _getRouteResult = () => {
        if (this.props.route.layerSet) {
            return (<div id="route-results">
                <div>Route: </div>
                <div className="geomap__route">
                    <div className="distance">{this._getDistanceStr(this.props.route.distance)}</div>
                    <div className="time">{this._getTimeStr(this.props.route.time)}</div>
                </div>
            </div>);
        }
        else return null;
    }

    private _getLayerSetButtons = () => {
        if (this.props.route.layerSet) {
            return (<>
                {this.props.searchAlongRouteAvailable ?
                    <Button handleClick={this._showPeriemterSearchContextMenu}
                        title={this.props.translations["GeoMap.SearchAlongRoute"]} iconName={"dot-circle"} />
                    : null}
                <Button handleClick={() => { this.props.clearRoute(this.props.route.id) }}
                    title={this.props.translations["GeoMap.EntferneRoute"]} iconName={"times"} />
            </>);
        }
    }

    private _showPeriemterSearchContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;
        this._perimeterSearchContextRef.setVisible(left, top);
    }

    private _getSearchButtons = () => {
        if (!this.props.route.isContextRoute) {
            return (<>
                <Button handleClick={() => { this.props.openAddressSearch(this.props.route.id) }}
                    title={this.props.translations["GeoMap.WegpunktAdresse"]} iconName={"home"} />
                <Button handleClick={() => { this.props.openMachineSearch(this.props.route.id) }}
                    title={this.props.translations["GeoMap.WegpunktMaschine"]} iconName={"cogs"} />
                <Button handleClick={() => { this.props.openResourceSearch(this.props.route.id) }}
                    title={this.props.translations["GeoMap.WegpunktRessource"]} iconName={"child"} />
                <Button handleClick={() => { this.props.openAssignmentSearch(this.props.route.id) }}
                    title={this.props.translations["GeoMap.WegpunktEinsatz"]} iconName={"calendar-check"} />
                <Button handleClick={() => { this.props.openTicketSearch(this.props.route.id) }}
                    title={this.props.translations["GeoMap.WegpunktTicket"]} iconName={"exclamation-circle"} />
            </>);
        }
        else {
            return null;
        }
    }

    private _getDistanceStr = (distance: number) => {
        let distanceToShow = distance / 1000;
        if (this.props.useMiles) {
            distanceToShow = Math.round(distanceToShow / this._conversionFactor);
        }
        else {
            distanceToShow = Math.round(distanceToShow);
        }
        return distanceToShow + (this.props.useMiles ? " mi" : " km");
    }

    private _getTimeStr = (time: number) => {
        let timeStr = "";
        let h = Math.floor(time / 60 / 60);
        timeStr = h + " " + this.props.translations["GeoMap.Std"] + " ";
        let remainingTime = time - (h * 60 * 60);
        let m = Math.floor(remainingTime / 60);
        timeStr += m + " " + this.props.translations["GeoMap.Min"] + " ";
        return timeStr;
    }

    private _handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        let header = $(event.currentTarget);
        let routeDiv = header.parent();
        let newStyle = this._collapsedStyle;
        if (this.state.collapsed) {
            newStyle = this._regularStyle;
            routeDiv.stop().animate(newStyle, 200, () => {
                header.next().slideToggle(0, () => {
                    this.setState({ collapsed: !this.state.collapsed });
                });
            });
        }
        else {
            header.next().slideToggle(0, () => {
                routeDiv.stop().animate(newStyle, 200, () => {
                    this.setState({ collapsed: !this.state.collapsed });
                });
            });
        }

    }

    private _droptargetOnDragEnter = (e: kendo.ui.DropTargetDragenterEvent) => {
        e.dropTarget.addClass("geomap__drag-target");
    }

    private _droptargetOnDragLeave = (e: kendo.ui.DropTargetDragleaveEvent) => {
        e.dropTarget.removeClass("geomap__drag-target");
    }

    private _droptargetOnDrop = (e: kendo.ui.DropTargetDropEvent) => {
        e.dropTarget.removeClass("geomap__drag-target");
        this.props.targetOnDrop(e, this.props.route.id, null);
    }

    private _getStyle = () => {
        return this.state.collapsed ? this._collapsedStyle : this._regularStyle;
    }

    private _getNameElement = () => {
        if (this.state.isEditMode) {
            return (<div className="geomap__route-header">
                <input className="k-textbox"
                    style={{ width: "100%", maxWidth: "340px" }} ref={(input) => { this.focusInput(input) }} onFocus={(e) => { this.selectText(e) }}
                    value={this.state.routeName} onChange={this.setRouteName} onBlur={(e) => { this.setEditable(e, false) }} />
            </div>)
        }
        else {
            return (<div className="geomap__route-header" style={this.state.collapsed ? { justifyContent: "center", alignItems: "center" } as React.CSSProperties : null} onClick={this._handleClick}>
                <div className="geomap__route-name-div">
                    <div style={!this.state.collapsed ? { marginLeft: "8px" } as React.CSSProperties : null}>{this._getRouteName()}</div>
                </div>
                {!this.state.collapsed && (!this.props.route.isContextRoute || this.props.route.waypoints.length > 0) ? this._getContextMenu() : null}
            </div>)
        }
    }

    private _setFocusToRoute = (e: React.MouseEvent) => {
        e.stopPropagation();
        this.props.setFocusToPins(this.props.route.id);
    }

    private _getRouteName = () => {
        if (this.state.collapsed) {
            let name = this.state.routeName as String;
            let strArr = name.split(" ");
            return strArr.length > 1 ? `${strArr[0].charAt(0)}${strArr[1].charAt(0)}` : strArr[0].charAt(0);
        }
        else {
            return this.state.routeName;
        }
    }

    private _openGoogleMapsUrlDialog = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        this.props.openGoogleMapsUrlDialog(this.props.route.id);
    }

    private _onContextMenuClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        let rect = e.currentTarget.getBoundingClientRect();
        this._contextMenuRef.style.right = (document.body.clientWidth - rect.right).toString() + "px";
        this._contextMenuRef.style.top = rect.top.toString() + "px";
        this._contextMenuRef.classList.add("geomap__context-menu--hovered");
    }

    private _copyContainer = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        this.props.copyContainer(this.props.route.id);
    }

    private _getContextMenu = () => {
        const toggleString = this.state.pinsHidden ? this.props.translations["GeoMap.ShowPins"] : this.props.translations["GeoMap.HidePins"];
        return (<div onClick={this._onContextMenuClick} style={{ padding: "0px 15px 0px 15px" }}><i className="fal fa-ellipsis-v fa-2x"></i>
            <div ref={(ref) => { this._contextMenuRef = ref; }} className="geomap__context-menu">
                {this.props.route.waypoints.length > 0 ?
                    <div onClick={this._openGoogleMapsUrlDialog} >
                        {this.props.translations["GeoMap.CreateGoogleMapsUrl"]}
                    </div>
                    : null
                }
                {!this.props.route.isContextRoute ?
                    <div onClick={(e) => { this.setEditable(e, true) }} >
                        {this.props.translations["GeoMap.ChangeContainerName"]}
                    </div>
                    : null
                }
                {this.props.route.waypoints.length > 1 ?
                    <div onClick={this._setFocusToRoute} >
                        {this.props.translations["GeoMap.BestFit"]}
                    </div>
                    : null
                }
                {this.props.route.waypoints.length > 0 ?
                    <div onClick={this.togglePins} >
                        {toggleString}
                    </div>
                    : null
                }
                {this.props.route.waypoints.length > 0 ?
                    <div onClick={this._copyContainer} >
                        {this.props.translations["GeoMap.CopyContainer"]}
                    </div>
                    : null
                }
                {!this.props.route.isContextRoute ?
                    <div onClick={(e) => { this.props.deleteRoute(e, this.props.route.id) }} >
                        {this.props.translations["GeoMap.DeleteContainer"]}
                    </div>
                    : null
                }
            </div>
        </div>)
    }

    togglePins = (e?: React.MouseEvent<HTMLDivElement>, buttonClicked?: boolean) => {
        this.props.togglePins(this.props.route.id);
        this.setState({ pinsHidden: !this.state.pinsHidden });
    }

    handleTogglePinsButtonClicked = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }

    setRouteName = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ routeName: e.target.value });
    }

    setEditable = (e: React.MouseEvent<HTMLDivElement> | React.FocusEvent<HTMLInputElement>, mode: boolean) => {
        e.stopPropagation();
        this.setState({ isEditMode: mode });
    }

    focusInput = (component: HTMLElement) => {
        if (component) {
            component.focus();
        }
    }

    selectText = (event: React.FocusEvent<HTMLInputElement>) => {
        if (event) {
            event.target.select();
        }
    }

    onPerimeterSearchEntryClick = (waypointType: WaypointType) => {
        this.props.openPerimeterSearch(this.props.route.id, waypointType);
    }

    setPerimeterSearchContextRef = (ref: PerimeterSearchContextMenu) => {
        this._perimeterSearchContextRef = ref;
    }

    markRoute = () => {
        this.props.markRoute(this.props.route.id);
    }

    removeRouteMarking = () => {
        this.props.removeRouteMarking();
    }

    static getDerivedStateFromProps(props: RouteProps, state: RouteState) {
        if (props.resetToggleState) {
            return {
                pinsHidden: false
            } as RouteState;
        }
        return null;
    }

    componentDidMount() {
        $(this._routeDivRef).kendoDropTarget({
            dragenter: this._droptargetOnDragEnter,
            dragleave: this._droptargetOnDragLeave,
            drop: this._droptargetOnDrop
        });

        this._routeDivRef.addEventListener("mouseenter", this.markRoute);
        this._routeDivRef.addEventListener("mouseleave", this.removeRouteMarking);
    }

    componentWillUnmount() {
        this._routeDivRef.removeEventListener("mouseenter", this.markRoute);
        this._routeDivRef.removeEventListener("mouseleave", this.removeRouteMarking);
    }

    render() {
        const translations: PerimeterSearchContextMenuTranslations = { address: this.props.translations["Adresse.Adresse"], machine: this.props.translations["Maschine.Maschine"], resource: this.props.translations["Ressource.Ressource"], assignment: this.props.translations["Einsatz.Einsatz"], ticket: this.props.translations["Vorgang.Ticket"] };
        return (<>
            <div className="geomap__route-div" style={this._getStyle()} ref={(r) => { this._routeDivRef = r; }}>
                {this._getNameElement()}
                <div style={{ display: this.props.route.hide ? "none" : "block" }}>
                    <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        {this.props.children}
                    </div>
                    <div style={this._buttonBarStyle}>
                        {this._getSearchButtons()}
                        {this._getRouteButtons()}
                        {this._getLayerSetButtons()}
                    </div>
                    {this._getRouteResult()}
                </div>
            </div>
            <PerimeterSearchContextMenu ref={this.setPerimeterSearchContextRef} onEntryClick={this.onPerimeterSearchEntryClick} translations={translations}></PerimeterSearchContextMenu>
        </>
        );
    }
}

export interface RouteProps extends DirectionsCommonProps {
    route: RouteObject;
    deleteRoute(e: React.MouseEvent<HTMLDivElement>, routeID: number): void;
    targetOnDrop(e: kendo.ui.DropTargetDropEvent, routeID: number, dropIdx: number): void;
    routeIndex: number;
    useMiles: boolean;
    resetToggleState?: boolean;
    searchAlongRouteAvailable?: boolean;
    openAddressSearch(routeID: number): void;
    openMachineSearch(routeID: number): void;
    openResourceSearch(routeID: number): void;
    openAssignmentSearch(routeID: number): void;
    openTicketSearch(routeID: number): void;
    draw(routeID: number): void;
    optimize(routeID: number): void;
    clearRoute(routeID: number): void;
    togglePins(routeID: number): void;
    setFocusToPins(routeID: number): void;
    openGoogleMapsUrlDialog(routeID: number): void;
    openPerimeterSearch(routeID: number, searchType: WaypointType): void;
    copyContainer(routeID: number): void;
    markRoute(routeID: number): void;
    removeRouteMarking(): void;
}

interface RouteState {
    routeName: string;
    collapsed: boolean;
    isEditMode: boolean;
    pinsHidden: boolean;
}

